export default __webpack_public_path__ + "static/img17h-b98260ef9486c19f0c00fc5ecc63c3aa.jpg";